import { ClipboardList, Store, Truck } from "lucide-react";

const STEPS = [
  {
    icon: ClipboardList,
    step: "01",
    title: "Discover Fresh, Local Products Straight from the Source",
    body: "Connect directly with local farmers, growers, ranchers, and producers who showcase their available products, seasonal harvests, and farm-fresh offerings. From locally grown fruits and vegetables to farm-raised meats, dairy, eggs, honey, fresh flowers, herbs, and more, Source2Table makes discovering local products simple and convenient.",
  },
  {
    icon: Store,
    step: "02",
    title: "Order Direct from Source",
    body: "Skip the middlemen and connect directly with the people behind your food. Source2Table's built-in messaging makes it easy to ask questions, confirm product availability, discuss pricing, and communicate directly with producers. Enjoy a more personal and transparent shopping experience, where you can make informed purchasing decisions while building meaningful connections with local businesses.",
  },
  {
    icon: Truck,
    step: "03",
    title: "Farm-Fresh Delivery or Pickup",
    body: "Choose from convenient pickup or delivery options offered by local producers. Whether collecting your order directly from the farm or having fresh products delivered to your door, Source2Table helps you explore available options and coordinate arrangements directly with the seller. Enjoy the flexibility of getting quality local products in a way that works best for you.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="bg-[#F9F6F0] py-20 md:py-32 px-4 sm:px-6 lg:px-12"
    >
      <div className="mx-auto max-w-7xl">
        <div className="max-w-2xl">
          <span className="text-xs sm:text-sm font-sans uppercase tracking-[0.2em] font-bold text-[#4A6B41]">
            How It Works
          </span>
          <h2 className="mt-3 font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1C241B] tracking-tight">
            A transparent path from&nbsp;
            <span className="whitespace-nowrap">
              Source<span className="text-[#4A6B41]">2</span>Table
            </span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {STEPS.map((s) => (
            <div
              key={s.step}
              data-testid={`how-step-${s.step}`}
              className="group relative rounded-3xl bg-white p-8 md:p-10 border border-[#D8E0D5] shadow-sm hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#4A6B41]/10 text-[#4A6B41] group-hover:bg-[#4A6B41] group-hover:text-[#F9F6F0] transition-colors duration-300">
                  <s.icon size={26} />
                </span>
                <span className="font-serif text-4xl text-[#D8E0D5]">
                  {s.step}
                </span>
              </div>
              <h3 className="mt-6 font-sans font-extrabold text-xl sm:text-2xl text-[#1C241B]">
                {s.title}
              </h3>
              <p className="mt-3 font-sans text-base text-[#5A6757] leading-relaxed">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
